module.exports = __webpack_public_path__ + "img/user.7470dc32.png";